module.exports = __webpack_public_path__ + "img/invest_advertising.c5d56f64.jpg";